export const TERMS_OF_USE_REQUEST_PENDING = 'terms_of_use_pending';
export const TERMS_OF_USE_REQUEST_RECEIVED = 'terms_of_use_received';
export const TERMS_OF_USE_REQUEST_ERROR = 'terms_of_use_request_error';
